import Alert from "@/components/common/Alert"

export  function NotFoundPaymentForm(){
    return(
        <Alert
            type="error"
            title="Pagamento indisponível"
            message="Pagamento não disponível ainda."
        />
    )
}